import type { AutosaveStatus } from '../../../hooks/useAutosave';
import { FONT } from './tokens';

/** CSS `font` shorthand in the compact type scale: weight, size, optional line-height. */
export const font = (w: number, size: number, lh?: number) => `${w} ${size}px${lh ? `/${lh}` : ''} ${FONT}`;

/** Combine several autosave statuses into one (worst wins). */
export function mergeStatus(...s: { status: AutosaveStatus; error: string | null; retry: () => void }[]) {
  const order: AutosaveStatus[] = ['invalid', 'error', 'saving', 'saved', 'idle'];
  for (const st of order) {
    const hit = s.find((x) => x.status === st);
    if (hit) return { status: st, error: hit.error, retry: () => s.forEach((x) => x.status === 'error' && x.retry()) };
  }
  return { status: 'idle' as AutosaveStatus, error: null, retry: () => {} };
}

